// extracted by mini-css-extract-plugin
export default {"ChangePasswordCard":"index__ChangePasswordCard__RelWX","EmailIcon":"index__EmailIcon__WaqBg","UnorderedList":"index__UnorderedList__TpP4T"};